<template>
    <div class="card" :class="{ 'opacity-50': milestone.has_passed }">
        <div class="flex items-center">
            <div>
                <span class="icon-circle bg-neutral-lightest">
                    <font-awesome-icon icon="flag-checkered" />
                </span>
                <span class="ml-md text-sm font-semibold">
                    <span class="mr-lg">{{ milestone.date }}</span><span class="text-neutral-dark">{{ milestone.name }}</span>
                </span>
            </div>
            <div class="ml-auto flex">
                <button
                    class="btn-icon hover:bg-danger hover:border-danger"
                    @click="deleteMilestone"
                >
                    <font-awesome-icon icon="trash-alt" size="xs" />
                </button>
                <button
                    class="btn-icon"
                    @click="$modal.show('add-edit-milestone', { milestone: milestone} )"
                >
                    <font-awesome-icon icon="pencil" size="sm" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            project: {
                required: true,
                type: Object,
            },
            milestone: {
                required: true,
                type: Object,
            },
        },

        methods: {
            deleteMilestone() {
                axios.delete(route('api.sales-projects.milestones.destroy', [this.project, this.milestone.id]))
                    .then(({ data }) => {
                        this.$emit('milestonesChanged', data);
                    })
                    .catch(() => {
                        flash_error('Delmålet kunde inte tas bort.');
                    });
            },
        },
    };
</script>
